import { Services } from '@ekhodealer/ekho-common';
import {
	ActionMenu,
	ActionMenuItem,
	ActionMenuTrigger,
	MoreButton,
	toast,
} from '@ekhodealer/ekho-common/rev';

import type { LeadsTableRow } from '@ekhodealer/ekho-common';

import { Leads24, Paperplane24, SquareUp24 } from '@common/components/icons';
import Inbox from '@common/components/icons/Inbox';
import { useCurrentServicesProvider } from '@common/hooks/useCurrentServicesProvider';

import { LeadDetailsTab } from '../atoms/leadDetailsDrawerAtoms';
import { useLeadNavigation } from '../hooks/useLeadNavigation';

export interface LeadActionMenuProps {
	item: LeadsTableRow;
}

export const LeadActionMenu = ({ item }: LeadActionMenuProps) => {
	const { openLeadDetails } = useLeadNavigation();
	const { data: servicesProvider } = useCurrentServicesProvider();
	const isBdcEnabled = servicesProvider?.config?.[Services.BDC]?.supported === true;

	// Action handlers
	const handleViewOverview = () => {
		openLeadDetails(item.id);
	};

	const handleViewConversations = (): void => {
		openLeadDetails(item.id, LeadDetailsTab.CONVERSATIONS);
	};

	const handleEmailLead = () => {
		// TODO: Implement email lead functionality
		toast({
			message: 'Email lead functionality coming soon',
			variant: 'info',
		});
	};

	const handleExportAsCsv = async () => {
		// TODO: Implement CSV export for single lead
		toast({
			message: 'CSV export functionality coming soon',
			variant: 'info',
		});
	};

	return (
		<ActionMenuTrigger>
			<MoreButton size='medium' aria-label={`More actions for lead ${item.name}`} />
			<ActionMenu>
				<ActionMenuItem
					label='View lead overview'
					leadingAccessory={<Leads24 />}
					onAction={handleViewOverview}
				/>
				{isBdcEnabled && (
					<ActionMenuItem
						label='View lead conversations'
						leadingAccessory={<Inbox size={24} />}
						onAction={handleViewConversations}
					/>
				)}
				<ActionMenuItem
					label='Email lead'
					leadingAccessory={<Paperplane24 />}
					onAction={handleEmailLead}
				/>
				<ActionMenuItem
					label='Export as CSV'
					leadingAccessory={<SquareUp24 />}
					onAction={handleExportAsCsv}
				/>
			</ActionMenu>
		</ActionMenuTrigger>
	);
};
